import { Controller } from "@hotwired/stimulus"
import { looksLikeCsvFile, validateCsvFile } from "../scripts/validate_csv"

// Drop this on any file input that expects a CSV:
//   data-controller="csv-validate" data-action="change->csv-validate#validateFile"
// For mixed PDF/CSV inputs, also set:
//   data-csv-validate-csv-extension-only-value="true"
export default class extends Controller {
  static values = {
    csvExtensionOnly: { type: Boolean, default: false }
  }

  connect() {
    this.fileInput = this.element.tagName === "INPUT" ? this.element : this.element.querySelector('input[type="file"]')
    this.form = this.fileInput?.closest("form")
    this.valid = true
    this.pending = false
    this.submitHandler = this.preventInvalidSubmit.bind(this)

    if (this.form) {
      // Capture so we can block the upload before rails-ujs disable-with runs.
      this.form.addEventListener("submit", this.submitHandler, true)
    }

    if (this.fileInput?.files?.[0]) {
      this.runValidation()
    }
  }

  disconnect() {
    if (this.form) {
      this.form.removeEventListener("submit", this.submitHandler, true)
    }
  }

  validateFile() {
    this.runValidation()
  }

  async runValidation() {
    const file = this.fileInput?.files?.[0]

    this.clearError()

    if (!file) {
      this.valid = true
      this.pending = false
      this.setSubmitDisabled(false)
      return
    }

    if (this.csvExtensionOnlyValue && !looksLikeCsvFile(file)) {
      this.valid = true
      this.pending = false
      this.setSubmitDisabled(false)
      return
    }

    this.pending = true
    this.valid = false
    this.setSubmitDisabled(true)

    try {
      const result = await validateCsvFile(file)
      this.pending = false

      if (!result.valid) {
        this.valid = false
        this.showError(result.message)
        this.setSubmitDisabled(true)
        return
      }

      this.valid = true
      this.setSubmitDisabled(false)
    } catch (error) {
      this.pending = false
      this.valid = false
      this.showError("Unable to read that CSV file. Please check the formatting and try again.")
      this.setSubmitDisabled(true)
    }
  }

  preventInvalidSubmit(event) {
    if (this.pending || this.valid === false) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }

  showError(message) {
    if (!this.fileInput) return

    this.fileInput.classList.add("is-invalid")

    let messageElement = this.fileInput.parentElement.querySelector(".csv-validate-message")
    if (!messageElement) {
      messageElement = document.createElement("div")
      messageElement.className = "invalid-feedback csv-validate-message"
      this.fileInput.insertAdjacentElement("afterend", messageElement)
    }

    messageElement.textContent = message
  }

  clearError() {
    if (!this.fileInput) return

    this.fileInput.classList.remove("is-invalid")

    const messageElement = this.fileInput.parentElement.querySelector(".csv-validate-message")
    if (messageElement) {
      messageElement.textContent = ""
    }
  }

  setSubmitDisabled(disabled) {
    if (!this.form) return

    this.form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach((button) => {
      button.disabled = disabled
    })
  }
}
